import { GoalMetricItemLink, GoalMetricItemLinkKind } from "@sp-crm/core";

const linkPrefixes: Record<GoalMetricItemLinkKind, string> = {
    placement: "/clients/show/",
    homeCare: "/home-care-clients/show/",
    referenceContact: "/references/contacts/show/",
    referenceBusiness: "/references/organizations/show/",
    community: "/communities/show/",
};

export const goalMetricItemHref = (link: GoalMetricItemLink): string =>
    `${linkPrefixes[link.kind]}${link.entityId}`;

export const formatGoalMetricItemDate = (date: string): string =>
    new Date(date).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        timeZone: "UTC",
    });
